import { render, staticRenderFns } from "./helpContent.vue?vue&type=template&id=35072c6c&scoped=true"
import script from "./helpContent.vue?vue&type=script&lang=js"
export * from "./helpContent.vue?vue&type=script&lang=js"
import style0 from "./helpContent.vue?vue&type=style&index=0&id=35072c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_cache-loader@4.1.0_webpack@4.47.0__css-load_e869bb83501a535456d8ad6b2e6cd142/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35072c6c",
  null
  
)

export default component.exports